import { pipe, uniqBy, filter, toArray } from '@fxts/core';
import { getYear } from 'date-fns';
import { isAfterOrSameYear, isBeforeOrSameYear } from './date.mjs';

function getYearCountInRange(startDate, endDate, excludeDates = []) {
  const startYear = getYear(startDate);
  const endYear = getYear(endDate);
  const yearCountInRange = endYear - startYear + 1;
  const excludedYearCount = pipe(
    excludeDates,
    uniqBy((excludeDate) => `${getYear(excludeDate)}`),
    filter((excludeDate) => {
      const isAfterOrSameStartYear = isAfterOrSameYear(excludeDate, startDate);
      const isBeforeOrSameEndYear = isBeforeOrSameYear(excludeDate, endDate);
      return isAfterOrSameStartYear && isBeforeOrSameEndYear;
    }),
    toArray
  ).length;
  return yearCountInRange - excludedYearCount;
}

export { getYearCountInRange as default };
//# sourceMappingURL=getYearCountInRange.mjs.map
